// extracted by mini-css-extract-plugin
export default {"content":"Summary_content__cBG+a","isMobile":"Summary_isMobile__pzkpL","mapContainer":"Summary_mapContainer__oZ-s9"};